<template>
    <el-dialog
        class="show-follow-dialog"
        :class="rightVisible ? 'show-follow-right' : 'show-follow-left'"
        :visible.sync="visible"
        center>
        <el-col :span="rightVisible ? 16 : 24">
            <div class="left" :class="rightVisible ? 'is-right-style' : 'is-left-style'">
                <div class="header">
                    <div class="fitness-title">
                        <el-form v-if="form" :model="form" v-loading="loading">
                            {{ messageInfo }}
                        </el-form>
                    </div>
                </div>
                <i class="el-icon-close" @click="visible = false"></i>
                <div class="table-list">
                    <div class="table-button">
                        <el-radio-group
                            v-model="activeName"
                            @change="handleClick"
                            class="show-follow-record">
                            <el-radio-button label="first">{{ $t('Common.base_info') }}</el-radio-button>
                            <el-radio-button label="second">{{ $t('Member.membership') }}</el-radio-button>
                            <el-radio-button label="third">{{ $t('Course.personal_lesson') }}</el-radio-button>
                            <el-radio-button label="forth">{{ $t('Common.locker') }}</el-radio-button>
                            <el-radio-button label="fifth">{{ $t('Card.card1') }}</el-radio-button>
                            <el-radio-button label="sixth">{{ $t('Reception.First.sign') }}</el-radio-button>
                            <el-radio-button label="seventh">{{ $t('Member.Follow.has_group') }}</el-radio-button>
                            <el-radio-button label="eighth">{{ $t('Board.Personal.title') }}</el-radio-button>
                            <el-radio-button label="nine">{{ $t('Member.Follow.integral') }}</el-radio-button>
                            <el-radio-button label="ten">{{ $t('Member.Follow.sms') }}</el-radio-button>
                            <el-radio-button label="eleven">{{ $t('Member.Follow.record') }}</el-radio-button>
                            <el-radio-button label="twelve">{{ $t('Common.followup_record') }}</el-radio-button>
                        </el-radio-group>
                    </div>
                    <el-tabs type="border-card">
                        <div class="first" v-if="activeName === 'first'">
                            <el-form
                                    ref="form"
                                    :model="form"
                                    label-width="120px"
                                    v-loading="loading"
                                    label-suffix=":"
                                    v-if="form">
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="name"
                                            :label="$t('Common.name')"
                                        >{{ form.name }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            :label="$t('Common.gender')"
                                            prop="gender"
                                        >{{ form.gender }}</el-form-item>
                                    </el-col>
                                    <!-- <el-form-item  prop="image" class="w-1/3" > -->
                                    <img
                                        :src="form.avatar"
                                        height="64"
                                        class="missing"
                                        style="padding: 0 50px;">
                                    <!-- </el-form-item> -->
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            :label="$t('Common.telephone_number')"
                                            prop="phone"
                                        >{{ form.phone }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            :label="$t('Common.birthday')"
                                        >{{ form.birthday }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <!-- <el-form-item :label="$t('Common.wechat')">{{ form.wechat }}</el-form-item> -->
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('Common.wechat')">{{ form.wechat }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-if="Number(form.typeCode) === 2">
                                        <el-form-item :label="$t('Contract.card_hao')">{{ form.cardNum }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start" v-if="Number(form.typeCode) === 2">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('Client.Add.referrer')"></el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('Client.phy_id')">{{ form.cardPhysicalId }}</el-form-item>
                                    </el-col>
                                </el-row>

                                <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            :label="$t('Common.distribution_saler')"
                                            prop="mshpSalesNickname">
                                            {{ form.mshpSalesNickname }}
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            :label="$t('Client.Add.follow_level')"
                                        >{{ form.followLevel }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            :label="$t('Client.Add.get_attributes')"
                                        >{{ form.channelSource }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            :label="$t('Client.Add.attributes')"
                                        >{{ form.channelAttr }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="certType"
                                            :label="$t('Client.Add.certificate_type')"
                                        >{{ form.certType }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="certNum"
                                            :label="$t('Client.Add.certificate_number')"
                                        >{{ form.certNum }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="citizenship"
                                            :label="$t('Client.Add.Country_of_Citizenship')"
                                        >{{ form.citizenship }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="nation"
                                            :label="$t('Client.Add.nation')"
                                        >{{ form.nation }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item prop="email" label="E-mail">{{ form.email }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="homeAddress"
                                            :label="$t('Client.address')"
                                        >{{ form.homeAddress }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="companyName"
                                            :label="$t('Client.Add.company_name')"
                                        >{{ form.companyName }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="companyPhone"
                                            :label="$t('Client.Add.company_phone')"
                                        >{{ form.companyPhone }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="contactName"
                                            :label="$t('Client.Add.emergency_contact')"
                                        >{{ form.contactName }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="contactPhone"
                                            :label="$t('Client.Add.contact_people')"
                                        >{{ form.contactPhone }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item prop="joinedClub" :label="$t('Client.Add.club')">
                                            {{ form.joinedClub }}
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item prop="fitnessPurpose" :label="$t('Client.Add.purpose')">
                                            {{ form.fitnessPurpose }}
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                                prop="wasFitnessMember"
                                                :label="$t('Client.Add.member_is')">
                                            {{ form.wasFitnessMember }}
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                                prop="leftReason"
                                                :label="$t('Client.Add.leave_reason')"
                                                v-if="form.wasFitnessMemberCode === 1"
                                        >{{ form.leftReason }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <div style="border-top:1px solid #ccc; margin: 20px 0 20px 0px;"></div>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="category"
                                            :label="$t('Client.Add.customer_type')"
                                        >{{ form.category }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="infoHabit"
                                            :label="$t('Client.Add.get_information_habits')"
                                        >{{ form.infoHabit }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg" justify="start">
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="marriage"
                                            :label="$t('Client.Add.marital_status')"
                                        >{{ form.marriage }}</el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item
                                            prop="children"
                                            :label="$t('Client.Add.child_situation')"
                                        >{{ form.children }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item
                                    prop="clientTagNames"
                                    :label="$t('Client.Add.customer_label')"
                                >{{ form.clientTagNames }}</el-form-item>
                                <el-form-item
                                    prop="mshpAt"
                                    :label="$t('Member.Desc.time')"
                                >{{ form.mshpAt }}</el-form-item>
                                <el-form-item
                                    prop="mshpAt"
                                    :label="$t('Week.entry_time')"
                                >{{ form.createdAt }}</el-form-item>
                            </el-form>
                        </div>
                        <div class="second" v-if="activeName === 'second'">
                            <el-table v-if="clientCard" :data="clientCard" class="my-4" v-loading="loading">
                                <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                                <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                                <el-table-column prop="storeName" :label="$t('Member.sign_store')" align="center"/>
                                <el-table-column prop="supportStoreNames" :label="$t('Reception.First.support_store')" align="center"/>
                                <el-table-column prop="cardName" :label="$t('Contract.card_name')" align="center"/>
                                <el-table-column prop="cardCredit" :label="$t('Contract.Desc.amount')" align="center" width="120"/>
                                <el-table-column prop="cardBalance" :label="$t('Contract.Desc.current_remaining')" align="center"/>
                                <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                                <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                                <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                                <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                                <el-table-column prop="activeCardWay" :label="$t('Member.open_card_method')" align="center"/>
                                <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                                <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                                <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                                <el-table-column prop="recommendClientName" :label="$t('Client.Add.referrer')" align="center"/>
                                <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                            </el-table>
                        </div>
                        <div class="third" v-if="activeName === 'third'">
                            <el-table v-if="coachLesson" :data="coachLesson" class="my-4" v-loading="loading">
                                <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                                <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                                <el-table-column prop="lessonName" :label="$t('Member.Follow.course_name')" align="center"/>
                                <el-table-column prop="lessonCredit" :label="$t('Member.buy_count')" align="center"/>
                                <el-table-column prop="lessonBalance" :label="$t('Member.Follow.course_quota')" align="center"/>
                                <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                                <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                                <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                                <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                                <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                                <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                                <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                                <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                            </el-table>
                        </div>
                        <div class="forth" v-if="activeName === 'forth'">
                            <el-table v-if="locker" :data="locker" class="my-4" v-loading="loading">
                                <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                                <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                                <el-table-column prop="lockerCode" :label="$t('Common.cabinet_number')" align="center"/>
                                <el-table-column prop="lease" :label="$t('Week.lease_period2')" align="center"/>
                                <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                                <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                                <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                                <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                                <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                                <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                                <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                                <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                            </el-table>
                        </div>
                        <div class="fifth" v-if="activeName === 'fifth'">
                            <el-table v-if="czCard" :data="czCard" class="my-4" v-loading="loading">
                                <el-table-column prop="contractNum" :label="$t('Contract.number')" align="center" width="100px"/>
                                <el-table-column prop="cardNum" :label="$t('Contract.card_hao')" align="center"/>
                                <el-table-column prop="cardName" :label="$t('Member.Follow.cards_name')" align="center"/>
                                <el-table-column prop="cardId" :label="$t('Member.Follow.cards_id')" align="center"/>
                                <el-table-column prop="cardCredit" :label="$t('Member.Follow.amt')" align="center"/>
                                <el-table-column prop="cardBalance" :label="$t('Contract.Desc.current_remaining')" align="center"/>
                                <el-table-column prop="type" :label="$t('Contract.type')" align="center"/>
                                <el-table-column prop="originalContractNum" :label="$t('Contract.Desc.old_number')" align="center"/>
                                <el-table-column prop="status" :label="$t('Contract.status')" align="center"/>
                                <el-table-column prop="createdAt" :label="$t('Sell.sign_date')" align="center"/>
                                <el-table-column prop="startAt" :label="$t('Contract.start_time')" align="center"/>
                                <el-table-column prop="endAt" :label="$t('Contract.end_time')" align="center"/>
                                <el-table-column prop="contractSalesStaffNickname" :label="$t('Member.saler')" align="center"/>
                                <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center"/>
                            </el-table>
                        </div>
                        <div class="sixth" v-if="activeName === 'sixth'">
                            <el-table v-if="enterData" :data="enterData" class="my-4" v-loading="loading">
                                <el-table-column type="index" :label="$t('Member.Follow.serial_number')" align="center"/>
                                <el-table-column prop="storeName" :label="$t('Common.enter_store')" align="center"/>
                                <el-table-column prop="cardName" :label="$t('Reception.Sixth.has_card')" align="center"/>
                                <el-table-column :label="$t('Reception.Sixth.kou')" align="center">
                                    <template slot-scope="{row}">
                                        {{ row.deduction ? `${row.deduction}${$t('Week.ci')}` : '/' }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="enterTime" :label="$t('Common.enter_time')" align="center"/>
                                <el-table-column prop="leaveTime" :label="$t('Common.outer_time')" align="center"/>
                                <el-table-column prop="temLockerCode" :label="$t('Member.Follow.temporary_locker')" align="center"/>
                            </el-table>
                        </div>
                        <div class="seventh" v-if="activeName === 'seventh'">
                            <el-table v-if="teamSchedule" :data="teamSchedule" class="my-4" v-loading="loading">
                                <el-table-column prop="index" :label="$t('Member.Follow.serial_number')" align="center"/>
                                <el-table-column prop="teamLessonName" :label="$t('Course.name2')" align="center"/>
                                <el-table-column prop="teamLessonTime" :label="$t('Course.time')" align="center"/>
                                <el-table-column prop="reserveWay" :label="$t('Member.Follow.appoint_methods')" align="center"/>
                                <el-table-column prop="status" :label="$t('Course.appoint_status')" align="center"/>
                                <el-table-column prop="createdAt" :label="$t('Reception.Second.appoint_time')" align="center"/>
                            </el-table>
                        </div>
                        <div class="eighth" v-if="activeName === 'eighth'">
                            <el-table
                                    v-if="coachSchedule"
                                    :data="coachSchedule"
                                    class="my-4"
                                    v-loading="loading">
                                <el-table-column prop="index" :label="$t('Member.Follow.serial_number')" align="center"/>
                                <el-table-column prop="coachLessonName" :label="$t('Member.Follow.personal_name')" align="center"/>
                                <el-table-column prop="coachLessonTime" :label="$t('Course.time')" align="center"/>
                                <el-table-column prop="actualCoachId" :label="$t('Course.coach')" align="center"/>
                                <el-table-column prop="actualCoachNickname" :label="$t('Member.Follow.coach_nickname')" align="center"/>
                                <el-table-column prop="lessonBalance" :label="$t('Course.Coach.remaining_sections')" align="center"/>
                            </el-table>
                        </div>
                        <div class="nine" v-if="activeName === 'nine'">
                            <el-table v-if="pointRecord" :data="pointRecord" class="my-4" v-loading="loading">
                                <el-table-column prop="id" :label="$t('Member.Follow.integral_id')" align="center" width="100px"/>
                                <el-table-column prop="point" :label="$t('Member.Follow.integral_number')" align="center"/>
                                <el-table-column prop="balance" :label="$t('Card.amt')" align="center"/>
                                <el-table-column prop="remark" :label="$t('Common.remark')" align="center"/>
                                <el-table-column prop="createdAt" :label="$t('Reception.Third.time')" align="center" width="120"/>
                            </el-table>
                        </div>
                        <div class="ten" v-if="activeName === 'ten'">
                            <el-table v-if="smsRecord" :data="smsRecord" class="my-4" v-loading="loading">
                                <el-table-column prop="id" :label="$t('Member.Follow.sms_id')" align="center" width="100px"/>
                                <el-table-column prop="createdAt" :label="$t('Member.Follow.send_time')" align="center"/>
                                <el-table-column prop="content" :label="$t('Member.Follow.send_content')" align="center"/>
                                <el-table-column prop="operatorNickname" :label="$t('Member.Follow.operat_staff')" align="center"/>
                                <el-table-column prop="operatorId" :label="$t('Member.Follow.operat_staff_id')" align="center" width="120"/>
                            </el-table>
                        </div>
                        <div class="eleven" v-if="activeName === 'eleven'">
                            <el-table v-if="assignRecord" :data="assignRecord" class="my-4" v-loading="loading">
                                <el-table-column prop="id" :label="$t('Member.Follow.record_id')" align="center" width="100px"/>
                                <el-table-column prop="preMshpSalesNickname" :label="$t('Member.Distribution.saler')" align="center"/>
                                <el-table-column prop="aftMshpSalesNickname" :label="$t('Member.Distribution.saler_after')" align="center"/>
                                <el-table-column prop="aftCoachNickname" :label="$t('Member.Distribution.coach')" align="center"/>
                                <el-table-column prop="preCoachNickname" :label="$t('Member.Distribution.coach_after')" align="center" width="120"/>
                                <el-table-column prop="assignStaffNickname" :label="$t('Member.Distribution.staff')" align="center" width="120"/>
                                <el-table-column prop="createdAt" :label="$t('Member.Distribution.time')" align="center" width="120"/>
                            </el-table>
                        </div>
                        <div class="twelve" v-if="activeName === 'twelve'">
                            <el-table v-if="followRecord" :data="followRecord" class="my-4" v-loading="loading">
                                <el-table-column prop="id" :label="$t('Member.Follow.id')" align="center" width="100px"/>
                                <el-table-column prop="recordType" :label="$t('Member.Follow.record_type')" align="center"/>
                                <el-table-column prop="remark" :label="$t('Member.Follow.record_remark')" align="center"/>
                                <el-table-column prop="followStaffId" :label="$t('Member.Follow.record_staff')" align="center"/>
                                <el-table-column prop="followStaffNickname" :label="$t('Member.Follow.record_staff_name')" align="center"/>
                                <el-table-column prop="createdAt" :label="$t('Member.Follow.time')" align="center" width="120"/>
                            </el-table>
                        </div>
                        <!-- 分页 -->
                        <el-pagination
                                v-if="showPage"
                                class="text-center"
                                @current-change="fetchData"
                                :current-page.sync="pagination.page"
                                :page-size="pagination.size"
                                layout="total, prev, pager, next, jumper"
                                :total="pagination.total"
                        ></el-pagination>
                    </el-tabs>
                </div>
            </div>
        </el-col>
        <!-- 添加跟进记录弹窗 -->
        <el-col :span="8" v-if="rightVisible">
            <div class="right">
                <div class="title">{{ $t('Member.Follow.add') }}</div>
                <i class=" icon-club el-icon-close" @click="rightVisible = false"></i>
                <div class="form">
                    <el-form
                        ref="addForm"
                        :model="addForm"
                        :rules="rules"
                        :status-icon="true"
                        label-position="right"
                        label-width="100px"
                        label-suffix=":">
                        <el-form-item prop="name" :label="$t('Member.name2')">
                            {{ addForm.name }}
                        </el-form-item>
                        <el-form-item prop="phone" :label="$t('Member.telephone')">
                            {{ addForm.phone }}
                        </el-form-item>
                        <el-form-item :label="$t('Common.store')" prop="storeId">
                            <el-select
                                v-model="addForm.storeId"
                                :placeholder="$t('Common.store')"
                                class="w-full">
                                <el-option
                                    v-for="(item, index) in stores"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.id"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Member.Follow.people')" prop="followStaffId">
                            <el-select
                                @change="searchFollow = null"
                                v-model="addForm.followStaffId"
                                :placeholder="$t('Common.please_choose')"
                                class="w-full">
                                <input
                                    type="text"
                                    class="search-input-all"
                                    v-model="searchFollow"/>
                                <el-option
                                    v-for="(item, index) in filterFollow"
                                    :key="index"
                                    :label="item.nickname"
                                    :value="item.id"
                                    :disabled="item.id === 'no'" />
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            class="show-follow-methods"
                            :label="$t('Member.Service.methods')"
                            prop="serviceMode"
                            v-if="followType === 'full'">
                            <el-radio-group
                                v-model="addForm.serviceMode">
                                <el-radio label="2" >{{ $t('Member.Service.phone') }}</el-radio>
                                <el-radio label="4" >{{ $t('Member.Service.sms') }}</el-radio>
                                <el-radio label="5" >{{ $t('Member.Service.face') }}</el-radio>
                                <el-radio label="6" >{{ $t('Member.Service.email') }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            :label="$t('Member.Service.purpose')"
                            prop="purpose"
                            v-if="followType !== 'full'">
                            <el-radio-group v-if="followType === 'potential'" v-model="addForm.purpose">
                                <el-radio label="7">{{ $t('Member.Service.saler') }}</el-radio>
                                <el-radio label="8">{{ $t('Member.Service.ti') }}</el-radio>
                            </el-radio-group>
                            <el-radio-group
                                v-if="followType === 'coach'"
                                prop="purpose"
                                v-model="addForm.purpose">
                                <el-radio label="9">{{ $t('Member.Service.fee_coach') }}</el-radio>
                                <el-radio label="10">{{ $t('Member.Service.body') }}</el-radio>
                                <el-radio label="11">{{ $t('Sell.Pay.other') }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            prop="status"
                            :label="$t('Member.Service.status')"
                            v-if="followType === 'full'">
                            <el-select
                                v-model="addForm.status"
                                :placeholder="$t('Common.please_choose')"
                                class="w-full">
                                <el-option
                                    v-for="(item, index) in fullOptions"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            prop="status"
                            v-if="followType !== 'full'"
                            :label="$t('Member.Service.status')">
                            <el-select
                                v-model="addForm.status"
                                :placeholder="$t('Common.please_choose')"
                                class="w-full"
                                clearable>
                                <el-option
                                    v-for="(item, index) in options"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('Client.communication_result')" prop="result">
                            <el-radio-group v-model="addForm.result">
                                <el-radio label="5">{{ $t('Member.Service.appoint_fail') }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('Member.Service.fail_reason')"
                            style="background: #eee;padding: 10px 10px 10px 0;">
                            <el-select
                                v-model="addForm.failReason"
                                :placeholder="$t('Common.please_choose')"
                                class="w-full">
                                <el-option
                                    v-for="(item, index) in options2"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code"/>
                            </el-select>
                        </el-form-item>

                        <!-- 教练跟进 -->
                        <template v-if="followType === 'coach'">
                            <el-form-item prop="result">
                                <el-radio-group
                                    @change="addForm.coachId = null;coachLessonStaffs = [];"
                                    v-model="addForm.result">
                                    <el-radio label="1">{{ $t('Lesson.FreeCourseReserva') }}</el-radio>
                                    <el-radio label="2">{{ $t('Lesson.PurchasedCourseReservat') }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <div style="background: #eee;padding: 18px 10px 1px 0;margin-bottom: 18px;">
                                <el-form-item
                                    :label="$t('Lesson.Appointmentcoach')"
                                    prop="coachId">
                                    <el-select
                                        @change="searchPersonal = null"
                                        v-model="addForm.coachId"
                                        :placeholder="$t('Common.please_choose')"
                                        class="w-full"
                                        clearable>
                                        <input type="text" class="search-input-all" v-model="searchPersonal"/>
                                        <el-option
                                            v-for="(item, index) in filterPersonalStaffs"
                                            :key="index"
                                            :label="item.nickname"
                                            :disabled="item.id === 'no'"
                                            :value="item.id"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Course.name')" prop="contractNum">
                                    <el-select
                                        @change="handleNum()"
                                        v-model="addForm.contractNum"
                                        :placeholder="$t('Common.please_choose')"
                                        class="w-full"
                                        clearable>
                                        <el-option
                                            v-for="(item, index) in coachLessonStaffs"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.contractNum"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item :label="$t('Lesson.Appointment_class')">
                                    <el-input
                                        type="text"
                                        style="width: 200px"
                                        v-model="addForm.quantity"/> {{ $t('Board.Team.festival') }}
                                </el-form-item>
                                <el-form-item
                                    :label="$t('Reception.Second.appoint_time')"
                                    prop="appointAt"
                                    class="show-follow-time">
                                    <el-date-picker
                                        v-model="addForm.appointAt"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :placeholder="$t('Week.Selectdate')">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                        </template>

                        <el-form-item v-if="followType === 'full'" prop="result">
                            <el-radio-group v-model="addForm.result">
                                <el-radio label="3">{{ $t('Card.appoint_success') }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="followType === 'potential'" prop="result">
                            <el-radio-group
                                @change="fetchStaff(addForm.result)"
                                v-model="addForm.result">
                                <el-radio label="3" >{{ $t('Card.Member_booking') }}</el-radio>
                                <el-radio label="4" >{{ $t('Card.LeagueBooking') }}</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <div
                            v-if="followType !== 'coach'"
                            style="background: #eee;padding: 18px 10px 1px 0;margin-bottom: 18px;">
                            <el-form-item
                                :label="Number(addForm.result) === 4 ? $t('Member.Follow.appoint_team_coach') : $t('Reception.Second.appoint_saler')"
                                v-if="followType !== 'coach'">
                                <el-select
                                    @change="searchCoach = searchStaff = null;"
                                    v-model="addForm.salesStaffId"
                                    :placeholder="$t('Common.please_choose')"
                                    class="w-full"
                                    clearable>
                                    <input
                                        v-if="Number(addForm.result) === 3"
                                        type="text"
                                        class="search-input-all"
                                        v-model="searchStaff"/>
                                    <el-option
                                        v-if="Number(addForm.result) === 3"
                                        v-for="(item, index) in filterStaff"
                                        :key="index"
                                        :label="item.nickname"
                                        :value="item.id"
                                        :disabled="item.id === 'no'"/>
                                    <input
                                        v-if="Number(addForm.result) === 4"
                                        type="text"
                                        class="search-input-all"
                                        v-model="searchCoach"/>
                                    <el-option
                                        v-if="Number(addForm.result) === 4"
                                        v-for="(item, index) in filterCoach"
                                        :key="index"
                                        :label="item.nickname"
                                        :value="item.id"
                                        :disabled="item.id === 'no'"/>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                :label="$t('Reception.Second.appoint_time')"
                                prop="appointAt"
                                class="show-follow-time">
                                <el-date-picker
                                    v-model="addForm.appointAt"
                                    :type="Number(addForm.result) === 4 ? 'date' : 'datetime'"
                                    :value-format="Number(addForm.result) === 4 ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
                                    :placeholder="$t('Week.Selectdate')">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item
                                :label="$t('Lesson.Appointment_course')"
                                v-if="followType !== 'full' && Number(addForm.result) === 4">
                                <el-select
                                    v-model="addForm.teamScheduleId"
                                    :placeholder="$t('Common.please_choose')"
                                    class="w-full"
                                    clearable>
                                    <el-option
                                        v-for="(item, index) in teams"
                                        :key="index"
                                        :label="item.lessonName"
                                        :value="item.id"/>
                                </el-select>
                            </el-form-item>
                        </div>

                        <el-form-item :label="$t('Lesson.Callcontent')" prop="content">
                            <el-input type="textarea" v-model="addForm.content"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Lesson.Nextcontacttime')" class="show-follow-time">
                            <el-date-picker
                                v-model="addForm.nextContactTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :placeholder="$t('Week.Selectdate')">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <span class="footer">
                        <el-button
                            :disabled="!$$filterPermission('客户-客户/会员管理-跟进')"
                            @click="handleStop">
                            {{ putData.followStatus === 3 ? '继续跟进' : '暂停跟进' }}
                        </el-button>
                        <el-button
                            :disabled="!$$filterPermission('客户-客户/会员管理-跟进')"
                            @click="submit"
                            type="primary">{{ $t('Common.save') }}</el-button>
                    </span>
                </div>
            </div>
        </el-col>
    </el-dialog>
</template>

<script>
import {
    Row,
    Col,
    Tooltip,
    Table,
    TableColumn,
    Pagination,
    Tabs,
    TabPane,
    Dialog,
    RadioButton,
    RadioGroup,
    DatePicker,
    Radio,
    Select,
} from 'element-ui';
import filterRole from '@/mixins/filterRole.js';

export default {
    components: {
        ElRow: Row,
        ElCol: Col,
        Tooltip: Tooltip,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElPagination: Pagination,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElDialog: Dialog,
        ElRadioButton: RadioButton,
        ElRadioGroup: RadioGroup,
        ElRadio: Radio,
        ElDatePicker: DatePicker,
        ElSelect: Select,
    },
    mixins: [filterRole],
    data() {
        return {
            visible: false,
            rightVisible: true,
            showPage: false,
            id: '',
            activeName: 'twelve',
            loading: false,
            form: null,
            clientCard: [],
            pointRecord: [],
            smsRecord: [],
            assignRecord: [],
            followRecord: [],
            coachLesson: [],
            teamSchedule: [],
            enterData: [],
            coachSchedule: [],
            locker: [],
            czCard: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            // 右侧跟进
            followType: '',  // potential-潜在客户 full-会员 coach-教练
            stores: [],
            // 销售
            staffs: [],
            // 团课教练
            staffsCoach: [],
            // 团课课程
            teams: [],
            // 确定添加数据
            addForm: {},
            // 规则
            rules: {
                storeId: { required: true, message: this.$t('Common.store_placeholder') },
                followStaffId: { required: true, message: this.$t('Lesson.select_follower') },
                // purpose: { required: true, message: '请选择通讯目的！' }, // 潜在&教练
                // status: { required: true, message: '请选择通讯状态！' },  // 会员
                result: { required: true, message: this.$t('Lesson.communication_result') },
                failReason: { required: true, message: this.$t('Lesson.failurereason') },
                content: { required: true, message: this.$t('Lesson.contents_of_call') },
            },
            options: [
                {
                    code: 1,
                    name: this.$t('Lesson.noanswer'),
                }, {
                    code: 2,
                    name: this.$t('Lesson.connect'),
                }, {
                    code: 3,
                    name: this.$t('Lesson.busy'),
                }, {
                    code: 4,
                    name: this.$t('Lesson.vacantnumber'),
                }, {
                    code: 5,
                    name: this.$t('Lesson.shutdown'),
                }, {
                    code: 6,
                    name: this.$t('Lesson.cut'),
                }, {
                    code: 7,
                    name: this.$t('Lesson.halt'),
                },
            ],
            options2: [
                {
                    code: 1,
                    name: this.$t('Lesson.Greetingphone'),
                }, {
                    code: 2,
                    name: this.$t('Lesson.Notime'),
                }, {
                    code: 3,
                    name: this.$t('Lesson.Uninterested'),
                }, {
                    code: 4,
                    name: this.$t('Lesson.Opinions_on_Club'),
                }, {
                    code: 5,
                    name: this.$t('Lesson.Opinions_on_service'),
                }, {
                    code: 6,
                    name: this.$t('Lesson.Opinions_on_League'),
                }, {
                    code: 7,
                    name: this.$t('Lesson.Opinions_on_coach'),
                }, {
                    code: 8,
                    name: this.$t('Reception.Fifth.price'),
                }, {
                    code: 9,
                    name: this.$t('Other.have_no_effect'),
                }, {
                    code: 10,
                    name: this.$t('Sell.Pay.other'),
                },
            ],
            postUrl: null,
            // 会员服务方式
            fullOptions: [],
            // 教练
            coachLessonStaffs: [],
            cardInfo: {},
            // 私教教练
            personalStaffs: [],
            putData: {
                followStatus: 2, // 2-跟进,3-暂停跟进
                followType: 1, // 1-销售跟进,2-教练跟进
            },
            // 所有跟进人
            allStaffs: [],
            messageInfo: null,
            // 跟进人
            searchFollow: null,
            searchStaff: null,
            searchCoach: null,
            searchPersonal: null,
        };
    },
    computed: {
        filterFollow() {
            if (!this.searchFollow) return this.allStaffs;
            const arr = this.allStaffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchFollow.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterStaff() {
            if (!this.searchStaff) return this.staffs;
            const arr = this.staffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchStaff.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterCoach() {
            if (!this.searchCoach) return this.staffsCoach;
            const arr = this.staffsCoach.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchCoach.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
        filterPersonalStaffs() {
            if (!this.searchPersonal) return this.personalStaffs;
            const arr = this.personalStaffs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchPersonal.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    watch: {
        rightVisible(val) {
            if (!val) {
                this.resetForm();
            }
        },
        'addForm.salesStaffId'(val) {
            if (val && this.followType === 'potential') this.fetchSchedule();
        },
        'addForm.appointAt'(val) {
            if (val && this.followType === 'potential') {
                this.fetchSchedule();
            }
        },
        'addForm.storeId'(val) {
            if (val && this.followType === 'potential') this.fetchSchedule();
            if (val && this.followType === 'coach') this.fetchLessons();
        },
        'addForm.coachId'(val) {
            if (val && this.followType === 'coach') this.fetchLessons();
        },
        'addForm.serviceMode'(val) {
            const full = this.followType === 'full';
            const email = Number(val) === 4 || Number(val) === 6;
            if (Number(val) === 2 && full) {
                this.fullOptions = this.options;
                this.addForm.status = 1;
            } else if (Number(val) === 5 && full) {
                this.fullOptions = [
                     {
                        code: 11,
                        name: this.$t('Lesson.faceerr'),
                    }, {
                        code: 12,
                        name: this.$t('Lesson.facesucc'),
                    },
                ];
                this.addForm.status = 12;
            } else if (full && email) {
                this.fullOptions = [
                    {
                        code: 8,
                        name: this.$t('Lesson.senderr'),
                    }, {
                        code: 9,
                        name: this.$t('Lesson.replied'),
                    }, {
                        code: 10,
                        name: this.$t('Lesson.noreply'),
                    },
                ];
                this.addForm.status = 9;
            }
        },
    },
    methods: {
        handleNum() {
            const data = this.coachLessonStaffs.find(el => el.contractNum === this.addForm.contractNum);
            this.addForm.coachLessonId = data.id;
        },
        getCreatAtTime(date) {
            const dateBegin = new Date(date);
            const dateEnd = new Date();
            const dateDiff = dateEnd.getTime() - dateBegin.getTime();
            // 计算出相差天数
            const dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));
            const leave1 = dateDiff % (24 * 3600 * 1000);
            const hours = Math.floor(leave1 / (3600 * 1000));
            // 计算相差分钟数
            const leave2 = leave1 % (3600 * 1000);
            const minutes = Math.floor(leave2 / (60 * 1000));
            // 计算相差秒数
            const leave3 = leave2 % (60 * 1000);
            const seconds = Math.round(leave3 / 1000);
            if (dayDiff) return `${dayDiff}${this.$t('Week.day2')}`;
            else if (hours) return `${hours}${this.$t('Week.hour')}`;
            else if (minutes) return `${minutes}${this.$t('Common.minute')}`;
            return `${seconds}${this.$t('Week.second')}`;
        },
        resetForm() {
            this.$refs.addForm.resetFields();
        },
        open(data, type) {
            this.followType = type;
            this.id = data.id;
            this.activeName = 'twelve';
            if (type === 'coach') this.putData.followStatus = data.coachFollowStatusCode;
            else this.putData.followStatus = data.salesFollowStatusCode;

            this.creatData(data);
            this.fetchData();
            this.fetchFollowRecord();
            this.fetchStore();
            if (type !== 'coach') this.fetchStaff(3);
            if (type === 'coach') {
                this.fetchStaff(5);
                this.fetchStaff(6);
            }
            this.fetchStaff();
            this.rightVisible = true;
            this.visible = true;
        },
        creatData(data) {
            let addForm;
            // 潜在客户
            if (this.followType === 'potential') {
                addForm = {
                    storeId: null,
                    followStaffId: null,
                    purpose: '7',
                    status: 1,
                    result: '5',
                    name: data.name,
                    phone: data.phone,
                    failReason: 1,
                    salesStaffId: null,
                    appointAt: null,
                    teamScheduleId: null,
                    content: null,
                    nextContactTime: null,
                };
                this.postUrl = `client/sales-follow-potential/${data.id}`;
                this.putData.followType = 1;
            } else if (this.followType === 'full') {
                addForm = {
                    storeId: null,
                    followStaffId: null,
                    serviceMode: '2',
                    status: 1,
                    result: '5',
                    name: data.name,
                    phone: data.phone,
                    failReason: 1,
                    salesStaffId: null,
                    appointAt: null,
                    teamScheduleId: null,
                    content: null,
                    nextContactTime: null,
                };
                this.postUrl = `client/sales-follow-full/${data.id}`;
                this.putData.followType = 1;
            } else if (this.followType === 'coach') {
                addForm = {
                    storeId: null,
                    followStaffId: null,
                    purpose: '9',
                    status: 1,
                    result: '5',
                    name: data.name,
                    phone: data.phone,
                    failReason: 1,
                    coachId: null,
                    coachLessonId: null,
                    quantity: null,
                    contractNum: null,
                    appointAt: null,
                    content: null,
                    nextContactTime: null,
                };
                this.postUrl = `client/coach-follow-client/${data.id}`;
                this.fetchCard(data.id);
                this.putData.followType = 2;
            }
            for (let prop in addForm) {
                this.$set(this.addForm, prop, addForm[prop]);
            }
        },
        fetchData() {
            this.loading = true;
            API.get(`client/${this.id}`)
            .then(res => {
                this.form = res;
                const date = this.getCreatAtTime(res.createdAt);
                this.messageInfo = `${this.$t('Member.Follow.base_info')}-${res.name} ${res.gender}
                (${res.type}| ${date}${this.$t('Member.Follow.enter_system')})`;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        // 左侧切换
        handleClick() {
            if (this.activeName === 'first') {
                this.showPage = false;
                this.fetchData();
            } else if (this.activeName === 'second') {
                this.showPage = false;
                this.fetchClientCard();
            } else if (this.activeName === 'third') {
                this.showPage = false;
                this.fetchCoachLesson();
            } else if (this.activeName === 'forth') {
                this.showPage = false;
                this.fetchLocker();
            } else if (this.activeName === 'fifth') {
                this.showPage = false;
                this.fetchCzCard();
            } else if (this.activeName === 'sixth') {
                this.showPage = true;
                this.fetchEnter();
            } else if (this.activeName === 'seventh') {
                this.showPage = false;
                this.fetchTeamSchedule();
            } else if (this.activeName === 'eighth') {
                this.showPage = false;
                this.fetchCoachSchedule();
            } else if (this.activeName === 'nine') {
                this.showPage = true;
                this.fetchPointRecord();
            } else if (this.activeName === 'ten') {
                this.showPage = true;
                this.fetchSmsRecord();
            } else if (this.activeName === 'eleven') {
                this.showPage = true;
                this.fetchAssignRecord();
            } else if (this.activeName === 'twelve') {
                this.showPage = true;
                this.fetchFollowRecord();
                this.right = true;
            }
        },
        fetchClientCard(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/contract-mshp`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.clientCard = res;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchPointRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/point-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.pointRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchSmsRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/sms-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.smsRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchAssignRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/assign-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.assignRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchFollowRecord(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/follow-record`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.followRecord = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchCoachLesson(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/contract-coach`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.coachLesson = res;
                // this.coachLesson = res.content;
                // this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchLocker(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/contract-locker`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.locker = res;
                // this.locker = res.content;
                // this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchCzCard(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/contract-cz-card`, {
                params: { ...this.pagination },
            })
            .then(res => {
                this.czCard = res;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchEnter(page = null) {
            if (page) this.pagination.page = page;
            API.get(`client/${this.id}/entrance-record`, {
                params: { ...this.pagination },
            }).then(res => {
                this.enterData = res.content;
                this.pagination.total = res.totalElements;
            });
        },
        fetchTeamSchedule() {
            this.loading = true;
            API.get(`client/${this.id}/team-schedule`)
            .then(res => {
                this.teamSchedule = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        fetchCoachSchedule() {
            this.loading = true;
            API.get(`client/${this.id}/coach-schedule`)
            .then(res => {
                this.coachSchedule = res;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        showImg(item) {
            this.img = item;
            this.isShowImg = true;
            this.index = this.form.albums.findIndex(el => el === item);
        },
        back() {
            this.$router.back();
        },
        // public - 跟进记录
        fetchStore() {
            API.get('store/list').then((res) => {
                this.stores = res;
                this.addForm.storeId = res[0].id;
            });
        },
        // 潜在客户跟进-通讯结果选择
        async fetchStaff(type) {
            this.addForm.salesStaffId = null;
            const storeId = this.addForm.storeId;
            if (Number(type) === 3) this.staffs = await this.filterRole(null, [5, 6], storeId);
            else if (Number(type) === 5)this.staffs = await this.filterRole(null, [7, 8, 9, 10], storeId);
            else if (Number(type) === 6) this.personalStaffs = await this.filterRole(null, [7, 8], storeId);
            else if (Number(type) === 4) this.staffsCoach = await this.filterRole(null, [6, 10], storeId, 'and');
            else this.allStaffs = await this.filterRole(null, null, storeId);
        },
        // 潜在客户团课选择 - 获取教练团课
        fetchSchedule() {
            this.teams = [];
            if (Number(this.addForm.result) === 4 && this.addForm.appointAt
            && this.addForm.storeId && this.addForm.salesStaffId) {
                this.addForm.teamScheduleId = null;
                this.teams = [];
                API.get('lesson/team/schedule/list', {
                    params: {
                        coachId: this.addForm.salesStaffId,
                        date: this.addForm.appointAt.split(' ')[0],
                        storeId: this.addForm.storeId,
                    },
                }).then(res => {
                    const array = this.addForm.appointAt.split(' ')[0].split('-');
                    const date = `${array[1]}-${array[2]}`;
                    res.map(el => {
                        if (el.date === date) {
                            this.teams.push({
                                id: el.id,
                                lessonName: `${el.lessonName}（${el.time}）`,
                            });
                        }
                    });
                });
            }
        },
        // 教练跟进-获取私教卡号
        fetchCard(id) {
            API.get(`client/${id}/init-contract?type=4`).then(res => {
                this.cardInfo = res;
            });
        },
        // 教练跟进-获取免费私教课程 - personalStaffs
        fetchLessons() {
            this.coachLessonStaffs = [];
            const num = Number(this.addForm.result);
            if (num === 1 && this.addForm.coachId && this.addForm.storeId) {
                API.get('lesson/coach/list', {
                    params: {
                        active: true,
                        coachId: this.addForm.coachId,
                        storeId: this.addForm.storeId,
                    },
                }).then(res => {
                    this.coachLessonStaffs = res;
                });
            } else if (num === 2 && this.addForm.coachId && this.addForm.storeId) {
                API.get('contract/coach/lesson', {
                    params: {
                        clientId: this.id,
                        coachId: this.addForm.coachId,
                        storeId: this.addForm.storeId,
                    },
                }).then(res => {
                    this.coachLessonStaffs = res;
                });
            }
        },
        submit() {
            // const rules = {
            //     storeId: { required: true, message: this.$t('Common.store_placeholder') },
            //     followStaffId: { required: true, message: '请选择跟进人' },
            //     // purpose: { required: true, message: '请选择通讯目的！' }, // 潜在&教练
            //     // status: { required: true, message: '请选择通讯状态！' },  // 会员
            //     result: { required: true, message: '请选择通讯结果！' },
            //     failReason: { required: true, message: '请选择未成功原因！' },
            //     content: { required: true, message: '请填写童话内容' },
            // };
            // this.rules = Object.assign({}, rules);
            const purpose = {purpose: { required: true, message: this.$t('Lesson.choosethepurpose') },};
            const status = {status: { required: true, message: this.$t('Member.Follow.choose_status') },};
            if (this.followType !== 'full') this.rules = Object.assign({}, this.rules, purpose);
            else this.rules = Object.assign({}, this.rules, status);
            this.$refs.addForm.validate((valid) => {
                if (!valid) return;
                if (valid && this.followType !== 'full' && !this.addForm.purpose) return false;
                if (valid && this.followType === 'full' && !this.addForm.status) return false;
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.addForm);
            delete form.name;
            delete form.phone;
            if (this.followType === 'potential') form.purpose = Number(form.purpose);
            form.result = Number(form.result);
            if (this.followType === 'full') form.serviceMode = Number(form.serviceMode);
            if (form.result === 4) delete form.appointAt;
            API.post(this.postUrl, form).then(res => {
                $ele.$message.success(this.$t('Message.save'));
                this.teams = [];
                this.$emit('fetchData');
                this.visible = false;
            });
        },
        handleStop() {
            const status = this.putData.followStatus;
            const msg = status === 2 || status === 1 ? this.$t('Message.stop_follow') : this.$t('Message.keep_follow');
            $ele.$confirm(msg, this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.put(`client/${this.form.id}/follow-status`, {
                    followStatus: status === 2 || status === 1 ? 3 : 2,
                    followType: this.putData.followType,
                }).then(res => {
                    $ele.$message.success(this.$t('Message.success'));
                    this.$emit('fetchData');
                    this.visible = false;
                });
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
    },
};
</script>
<style lang="scss">
.show-follow-dialog {
    .el-dialog {
        width: 1200px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 650px;
        overflow-y: hidden;
    }
    .el-dialog__body {
        max-height: 100% !important;
        margin-left: 0;
    }
    .el-dialog__close {
        display: none;
    }
    .table-list {
        height: 560px;
        overflow-y: auto;
    }
    .right {
        .form {
            height: 540px;
            overflow-y: auto;
            padding-bottom: 10px;
        }
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    &.show-follow-right {
        .el-dialog--center .el-dialog__body {
            padding: 0 65px 0 25px !important;
        }
    }
    &.show-follow-left {
        .el-dialog--center .el-dialog__body {
            padding: 0 25px !important;
        }
    }
}
.left {
    position: relative;
    &.is-right-style {
        padding-right: 25px;
    }
    .el-icon-close {
        position: absolute;
        right: 20px;
        top: 5px;
        font-size: 26px;
        cursor: pointer;
    }
    .fitness-title {
        font-size: 12px;
        font-weight: 400;
        height: 40px;
        padding: 15px 5px 10px 5px;
        border-bottom: 1px solid #e6e6e6;
        margin-bottom: 15px;
    }
}
.right {
    width: 435px;
    border-left: 1px solid black;
    position: relative;
    padding: 15px;
     .el-icon-close {
         position: absolute;
         right: 20px;
         top: 5px;
         font-size: 26px;
         cursor: pointer;
     }
    .title {
        font-size: 12px;
        font-weight: 400;
        padding: 0 5px 10px 5px;
        border-bottom: 1px solid #e6e6e6;
        margin-top: auto;
        margin-bottom: 15px;
    }
    .footer {
        text-align: center!important;
        margin-left: 150px;
    }
    .show-follow-time {
        .el-date-editor {
            width: 100%;
        }
    }
}
.show-follow-record {
    .el-radio-button {
        margin: 0 15px 15px 0;
    }
    .el-radio-button--small .el-radio-button__inner {
        border-left: 1px solid #dcdfe6;
        border-radius: 3px;
        background: #f7f7f7;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        box-shadow: none;
        background: #409EFF;
    }
}
.show-follow-methods {
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }
    .el-radio {
        margin-left: 0px;
        margin-right: 10px;
        margin-top: 10px;
    }
}
</style>
